export const SURVEYEFFORT = "";
export const SURVEYBREADCRUMB = "";
export const SURVEYPRIMARY = "decoy_trial";
export const SURVEYTERTIARY = "";
export const REFBREADCRUMB = "";
export const SURVEYPRIMARYPHOTO = "survey_photo_decoy";
export const SURVEYSECONDARYPHOTO = "";
export const SURVEYTERTIARYPHOTO = "";
export const SURVEYSECONDARY = "decoy_trial";
export const tabTableMap = {};
export const SURVEYEFFORTFIELDS = [];

export const SURVEYBREADCRUMBFIELDS = [];

export const SURVEYPRIMARYFIELDS = [
  { key: "id", type: "number", label: "Trial ID", keyField: true },
  { key: "deploy_date", label: "Deploy Date", type: "text", keyField: true },
  { key: "decoy_id", label: "Decoy Id", default: "", required: true },
  { key: "recovered_ts", label: "Recovered", type: "text" },
  { key: "longitude_wgs84", label: "Longitude", type: "number" },
  { key: "latitude_wgs84", label: "Latitude", type: "number" },
  { key: "cover_type", label: "Cover Type", default: "n/data" },
  {
    key: "light_distance_m",
    label: "Light Distance (m)",
    type: "number",
    default: -999,
  },
  {
    key: "strata",
    type: "select",
    label: "Strata",
  },
  { key: "ts", type: "text" },
  { key: "tablet_code", type: "text" },
  { key: "observer_code", type: "text" },
  { key: "actual_longitude_wgs84", type: "number" },
  { key: "actual_latitude_wgs84", type: "number" },
  { key: "actual_cover_type", label: "Actual Cover Type", default: "n/data" },
  {
    key: "actual_light_distance_m",
    label: "Actual Light Distance (m)",
    type: "number",
    default: -999,
  },
  { key: "actual_strata", type: "select", label: "Actual Strata" },
  { key: "comment", label: "Comment", type: "text" },
];
export const SURVEYSECONDARYFIELDS = [
  { key: "id", type: "number", keyField: true },
  { key: "deploy_date", type: "text", keyField: true },
  { key: "longitude_wgs84", type: "number" },
  { key: "latitude_wgs84", type: "number" },
  { key: "cover_type", label: "Cover Type", default: "n/data" },
  {
    key: "light_distance_m",
    label: "Light Distance (m)",
    type: "number",
    default: -999,
  },
  {
    key: "strata",
    type: "select",
    label: "Strata",
  },
  { key: "ts", type: "text" },
  { key: "tablet_code", type: "text" },
  { key: "observer_code", type: "text" },
  { key: "actual_longitude_wgs84", type: "number" },
  { key: "actual_latitude_wgs84", type: "number" },
  { key: "decoy_id", label: "Decoy Id", default: "", required: true },
  { key: "actual_cover_type", label: "Actual Cover Type", default: "n/data" },
  {
    key: "actual_light_distance_m",
    label: "Actual Light Distance (m)",
    type: "number",
    default: -999,
  },
  { key: "actual_strata", type: "select", label: "Actual Strata" },
  { key: "recovered_ts", label: "Recovered", type: "text" },
  { key: "comment", label: "Comment", type: "text" },
];

export const PHOTOFIELDS = [
  { key: "id", type: "number" },
  { key: "ts", type: "text", keyField: true },
];
